<mat-toolbar class="container-header">
    <mat-toolbar-row class="nav_isologo">
        <img class="isologo" src="assets/images/logo_navbar_blanco_solo.svg" alt="isologo de InventigAr"
        routerLink="/home" routerLinkActive="active">    
    </mat-toolbar-row>  
</mat-toolbar>